import React, { useState } from "react";
import PropTypes from "prop-types";
import SelectLocation from "../dropdown";
import { Link } from "react-router-dom";

FormSearch.propTypes = {};

function FormSearch({ setSearchWord, handleSearch, resetJobList, searchWord }) {
  const [isOpen, setIsOpen] = useState(null);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section className="form-sticky stc1">
      <div className="tf-container">
        <div className="job-search-form form inner-form-map st1">
          <form onSubmit={(e) => {
            e.preventDefault();   // 🚫 stops reload
            handleSearch();       // ✅ your logic
          }}
          >
            <div className="row-group-search">
              <div className="form-group-1">
                <input
                  type="text"
                  className="input-filter-search"
                  placeholder="title, company or location (Wales, England, Scotland, Northern Ireland)"
                  onChange={(e) => setSearchWord(e.target.value)}
                />
                <span className="icon-search search-job"></span>
              </div>
              {/* <div className="form-group-2">
                <span className="icon-map-pin"></span>
                <SelectLocation />
              </div> */}
              <div className="form-group-4">
                <button type="submit" className="btn btn-find">Find Jobs</button>
              </div>
            </div>
          </form>
        </div>
        {searchWord.length > 0 && (
          <>
            <br />
            <span className="icon-search search-job"></span> <Link to="#" onClick={() => { setSearchWord(""); resetJobList(); }}>Clear search</Link>
          </>
        )}
      </div>
    </section>
  );
}

export default FormSearch;
